export default {
  Detail: {
    ActiveCheckbox: 'Theo dõi',
  },
  Transfer: {
    Title: 'Chuyển đổi Chương',
    FromChapter: 'Chuyển từ chương',
    ToChapter: 'Chuyển đến chương',
    HasPeriod: 'Có điều kiện thời gian',
    ValidateTitle: 'Chương không hợp lệ',
    ValidateContent: 'Chương cũ và chương mới không được trùng nhau. Vui lòng kiểm tra lại.',
    TransferSuccess: 'Chuyển đổi chương thành công',
  }
};
